import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Table } from 'semantic-ui-react'
import CustomIcon from '~/components/CustomIcon'
import { FormFields } from '~/components/FormFields'
import { formatNumber } from '~/utils/helpers'

interface Props {
  index: number
  handleOpenModal: (index: number) => void
  waterUnitOptions: Array<{ key: number; value: number; text: string }>
}

const IrrigationEvent: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { index, handleOpenModal, waterUnitOptions } = props
  const { control } = useFormContext()

  const watchCropArea = useWatch({ control, name: 'cropArea' })
  const watchIrrigatedArea = useWatch({ control, name: `irrigationEvents[${index}].irrigatedArea` })
  const watchAddedWater = useWatch({ control, name: `irrigationEvents[${index}].addedWater` })

  function getLitrePerHa() {
    const water = watchIrrigatedArea ? parseInt(watchAddedWater) : 0
    const irrigatedArea = watchIrrigatedArea ? parseFloat(watchIrrigatedArea.toString().replace(',', '.')) / 100 : 0
    return `${formatNumber(water * irrigatedArea / parseInt(watchCropArea), 0)} litre / ha`
  }

  return <>
    <Table.Cell>
      <strong>{t('event')} {index + 1}</strong>
    </Table.Cell>
    <Table.Cell>
      <FormFields.Input
        control={control}
        name={`irrigationEvents[${index}].addedWater`}
        withoutAsterisk
        placeholder={t('Water')}
        typeInput='controled'
        noErrorMessage
        rules={{ required: true }}
      />
    </Table.Cell>
    <Table.Cell>
      <FormFields.Select
        control={control}
        name={`irrigationEvents[${index}].addedWaterUnit`}
        withoutAsterisk
        options={waterUnitOptions}
        placeholder={t('Unit')}
        noErrorMessage
        rules={{ required: true }}
      />
    </Table.Cell>
    <Table.Cell>
      <FormFields.Input
        control={control}
        name={`irrigationEvents[${index}].irrigatedArea`}
        withoutAsterisk
        placeholder={t('%')}
        typeInput='controled'
        allowDecimals
        decimalScale={2}
        noErrorMessage
        rules={{ required: true }}
      />
    </Table.Cell>
    <Table.Cell>
      <div>{getLitrePerHa()}</div>
    </Table.Cell>
    <Table.Cell textAlign='center'>
      <CustomIcon
        name='pencil'
        style={{ fontSize: '1.3em' }}
        onClick={() => handleOpenModal(index)}
      />
    </Table.Cell>
  </>
}
export default IrrigationEvent